import { CreateEventProperties, EventDataProperties } from './calendarProperties';
import { LocationTypes } from './soapNoteProperties';

export type SessionDataProperties = CreateEventProperties;

export enum TargetSessionStatuses {
	'new',
	'open',
	'active',
	'hidden',
}

export interface ActiveSessionTargetsProperties {
	correctPercentage: number;
	id: string;
	independent: number;
	name: string;
	orderId: number;
	programId: string;
	programName: string;
	prompt: number;
	targetInstructions: string;
	targetSessionStatus: TargetSessionStatuses;
	trials: number;
	typeId: number;
	typeName: string;
}

export interface UpdateSessionProperties {
	date: string;
	endTime: string;
	id: string;
	startTime: string;
}

export interface SupervisedSessionInfoProperties extends EventDataProperties {
	location: LocationTypes;
}

export interface GetSessionTypeProperties {
	clientId?: string;
	date?: string;
	userId?: string;
}

export interface UnlockSessionProperties {
	eventId: string;
	isAdminForceOperation?: boolean;
	nextExpirationDate: string;
}
